import useAppState from 'utils/state'

export default function useDelivery() {
    const { delivery } = useAppState()

    const checkDelivery = filter => {
        if (delivery === 'lt') {
            return filter
        }
        return `${filter} && all_deliveries:${delivery}`
    }

    return { checkDelivery }
}
